import React from 'react';

const Lock = ({ className = '', title = '' }) => {
  return (
    <svg width="46" height="63" viewBox="0 0 46 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <path d="M6 26.1818C4.34315 26.1818 3 27.525 3 29.1818V57C3 58.6569 4.34315 60 6 60H40C41.6569 60 43 58.6569 43 57V29.1818C43 27.525 41.6569 26.1818 40 26.1818H37.8785C38.1853 25.7112 38.3636 25.1492 38.3636 24.5455V18.3636C38.3636 9.87853 31.4851 3 23 3C14.5149 3 7.63636 9.87853 7.63636 18.3636V24.5455C7.63636 25.1492 7.81468 25.7112 8.12153 26.1818H6Z" stroke="#54322B" strokeWidth="6" strokeLinejoin="round"/>
      <path d="M29 40.1818C29 43.5959 26.3137 46.3636 23 46.3636C19.6863 46.3636 17 43.5959 17 40.1818C17 36.7677 19.6863 34 23 34C26.3137 34 29 36.7677 29 40.1818Z" fill="#54322B"/>
      <path d="M20 43.2727C20 41.5657 21.3431 40.1818 23 40.1818C24.6569 40.1818 26 41.5657 26 43.2727V47.9091C26 49.6162 24.6569 51 23 51C21.3431 51 20 49.6162 20 47.9091V43.2727Z" fill="#54322B"/>
      <line x1="4" y1="26.5" x2="43" y2="26.5" stroke="#54322B" strokeWidth="5"/>
    </svg>
  )
};

export default Lock;
